<div class="kylii-upload">
	<td-file-upload #fileUpload defaultColor="accent" activeColor="warn" cancelColor="primary" (select)="selectEvent($event)" (upload)="uploadEvent($event)" (cancel)="cancelEvent()" accept="{{accept}}" [disabled]="disabled" multiple>
		<mat-icon>file_upload</mat-icon><span>{{ fileUpload.files?.name }}</span>
		<ng-template td-file-input-label>
			<mat-icon>attach_file</mat-icon><span>{{description}}</span>
		</ng-template>
	</td-file-upload>
</div>

